import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const VehicleImageCarousel = ({ images, carId, altText, thumbSize = '400x300' }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextImage = (e) => {
    e.stopPropagation(); // Évite de déclencher le clic sur la carte parent
    if (!images || images.length <= 1) return;
    setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  const prevImage = (e) => {
    e.stopPropagation(); // Évite de déclencher le clic sur la carte parent
    if (!images || images.length <= 1) return;
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  if (!images || images.length === 0) {
    return (
      <div className="carousel-container no-image">
        <div className="no-img-placeholder">🚗</div>
        <style jsx>{`
          .carousel-container { width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; background: #f1f5f9; }
          .no-img-placeholder { font-size: 4rem; }
        `}</style>
      </div>
    );
  }

  return (
    <div className="carousel-container">
      <img 
        src={`https://christophedepanne.infocolab.online/api/files/car_listings/${carId}/${images[currentIndex]}?thumb=${thumbSize}`} 
        alt={`${altText} - Vue ${currentIndex + 1}`} 
        className="carousel-img"
      />
      
      {images.length > 1 && (
        <>
          <button className="carousel-btn prev-btn" onClick={prevImage}>
            <ChevronLeft size={20} />
          </button>
          <button className="carousel-btn next-btn" onClick={nextImage}>
            <ChevronRight size={20} />
          </button>
          
          <div className="carousel-indicators">
            {images.map((_, idx) => (
              <span 
                key={idx} 
                className={`indicator ${idx === currentIndex ? 'active' : ''}`}
                onClick={(e) => {
                  e.stopPropagation();
                  setCurrentIndex(idx);
                }}
              />
            ))}
          </div>
        </>
      )}

      <style jsx>{`
        .carousel-container {
          position: relative;
          width: 100%;
          height: 100%;
          overflow: hidden;
          background: #f1f5f9;
        }

        .carousel-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.5s ease;
        }

        .carousel-btn {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          background: rgba(255, 255, 255, 0.8);
          border: none;
          width: 32px;
          height: 32px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          color: #1e293b;
          opacity: 0;
          transition: opacity 0.2s, background 0.2s;
          z-index: 2;
          box-shadow: 0 2px 5px rgba(0,0,0,0.2);
        }

        .carousel-container:hover .carousel-btn {
          opacity: 1;
        }

        .carousel-btn:hover {
          background: white;
        }

        .prev-btn { left: 10px; }
        .next-btn { right: 10px; }

        .carousel-indicators {
          position: absolute;
          bottom: 10px;
          left: 0;
          right: 0;
          display: flex;
          justify-content: center;
          gap: 6px;
          z-index: 2;
        }

        .indicator {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.5);
          cursor: pointer;
          transition: all 0.2s;
          box-shadow: 0 1px 2px rgba(0,0,0,0.3);
        }

        .indicator.active {
          background: white;
          transform: scale(1.2);
        }
      `}</style>
    </div>
  );
};

export default VehicleImageCarousel;
